var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var KupaIcon = function (props) {
    return (_jsxs("svg", __assign({ width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [_jsx("path", { d: "M6.00069 3.08023C6.00069 3.08023 6.91298 1.75293 8.29519 1.68768C10.0268 1.60526 11.1922 2.83812 11.2748 4.22723C11.3574 5.60089 10.3883 6.83718 9.60511 7.67854C8.54134 8.82211 6.93956 10.1511 5.99973 10.8002C5.14251 10.2095 3.45487 8.81868 2.3911 7.67339C1.60963 6.83203 0.64053 5.5923 0.724874 4.22036C0.809218 2.83125 1.97799 1.60011 3.7079 1.68425C5.09012 1.75122 6.00069 3.08023 6.00069 3.08023Z", fill: "url(#paint0_linear_9374_26116)" }), _jsx("defs", { children: _jsxs("linearGradient", { id: "paint0_linear_9374_26116", x1: "5.99973", y1: "1.68018", x2: "5.99973", y2: "10.8002", gradientUnits: "userSpaceOnUse", children: [_jsx("stop", { "stop-color": "#F0052F" }), _jsx("stop", { offset: "1", "stop-color": "#940136" })] }) })] })));
};
export default KupaIcon;
